module.exports = __webpack_public_path__ + "img/AION.829208aa.svg";